"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unpack_markets = exports.unpack_assets = exports.PoolAsset = exports.PoolHeader = exports.PoolStatusID = exports.PUBKEY_LENGTH = exports.SelfTradeBehavior = exports.OrderType = exports.OrderSide = void 0;
const web3_js_1 = require("@solana/web3.js");
const utils_1 = require("./utils");
// Serum analog types
var OrderSide;
(function (OrderSide) {
    OrderSide[OrderSide["Bid"] = 0] = "Bid";
    OrderSide[OrderSide["Ask"] = 1] = "Ask";
})(OrderSide = exports.OrderSide || (exports.OrderSide = {}));
var OrderType;
(function (OrderType) {
    OrderType[OrderType["Limit"] = 0] = "Limit";
    OrderType[OrderType["ImmediateOrCancel"] = 1] = "ImmediateOrCancel";
    OrderType[OrderType["PostOnly"] = 2] = "PostOnly";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var SelfTradeBehavior;
(function (SelfTradeBehavior) {
    SelfTradeBehavior[SelfTradeBehavior["DecrementTake"] = 0] = "DecrementTake";
    SelfTradeBehavior[SelfTradeBehavior["CancelProvide"] = 1] = "CancelProvide";
    SelfTradeBehavior[SelfTradeBehavior["AbortTransaction"] = 2] = "AbortTransaction";
})(SelfTradeBehavior = exports.SelfTradeBehavior || (exports.SelfTradeBehavior = {}));
exports.PUBKEY_LENGTH = 32;
const STATUS_PENDING_ORDER_FLAG = 1 << 6;
const STATUS_PENDING_ORDER_MASK = 0x3f;
const STATUS_LOCKED_FLAG = 2 << 6;
const STATUS_UNLOCKED_FLAG = STATUS_PENDING_ORDER_MASK;
var PoolStatusID;
(function (PoolStatusID) {
    PoolStatusID[PoolStatusID["Uninitialized"] = 0] = "Uninitialized";
    PoolStatusID[PoolStatusID["Unlocked"] = 1] = "Unlocked";
    PoolStatusID[PoolStatusID["Locked"] = 2] = "Locked";
    PoolStatusID[PoolStatusID["PendingOrder"] = 3] = "PendingOrder";
    PoolStatusID[PoolStatusID["LockedPendingOrder"] = 4] = "LockedPendingOrder";
})(PoolStatusID = exports.PoolStatusID || (exports.PoolStatusID = {}));
class PoolHeader {
    constructor(serumProgramId, seed, signalProvider, status, numberOfMarkets, feeRatio, lastFeeCollectionTimestamp, feeCollectionPeriod) {
        this.serumProgramId = serumProgramId;
        this.seed = seed;
        this.signalProvider = signalProvider;
        this.status = status;
        this.numberOfMarkets = numberOfMarkets;
        this.feeRatio = feeRatio;
        this.lastFeeCollectionTimestamp = lastFeeCollectionTimestamp;
        this.feeCollectionPeriod = feeCollectionPeriod;
    }
    static match_status(status_byte) {
        let sByte = status_byte.readInt8(0);
        switch (sByte >> 6) {
            case 0:
                if (status_byte.readInt8(0) == 0) {
                    return [PoolStatusID.Uninitialized, 0];
                }
                return [PoolStatusID.Unlocked, 0];
            case 1:
                return [
                    PoolStatusID.PendingOrder,
                    (sByte & STATUS_PENDING_ORDER_MASK) + 1,
                ];
            case 2:
                return [PoolStatusID.Locked, 0];
            case 3:
                return [
                    PoolStatusID.LockedPendingOrder,
                    (sByte & STATUS_PENDING_ORDER_MASK) + 1,
                ];
            default:
                throw 'Pool status byte could not be parsed.';
        }
    }
    static fromBuffer(buf) {
        const serumProgramId = new web3_js_1.PublicKey(buf.slice(0, 32));
        const seed = buf.slice(32, 64);
        const signalProvider = new web3_js_1.PublicKey(buf.slice(64, 96));
        const status = PoolHeader.match_status(buf.slice(96, 97));
        // @ts-ignore
        const numberOfMarkets = utils_1.Numberu16.fromBuffer(buf.slice(97, 99));
        const feeRatio = utils_1.Numberu16.fromBuffer(buf.slice(99, 101));
        const lastFeeCollectionTimestamp = utils_1.Numberu64.fromBuffer(buf.slice(101, 109));
        const feeCollectionPeriod = utils_1.Numberu64.fromBuffer(buf.slice(109, 117));
        return new PoolHeader(serumProgramId, seed, signalProvider, status, numberOfMarkets, feeRatio, lastFeeCollectionTimestamp, feeCollectionPeriod);
    }
}
exports.PoolHeader = PoolHeader;
PoolHeader.LEN = 117;
class PoolAsset {
    constructor(mintAddress) {
        this.mintAddress = mintAddress;
    }
    toBuffer() {
        return Buffer.concat([this.mintAddress.toBuffer()]);
    }
    static fromBuffer(buf) {
        const mintAddress = new web3_js_1.PublicKey(buf.slice(0, 32));
        return new PoolAsset(mintAddress);
    }
}
exports.PoolAsset = PoolAsset;
PoolAsset.LEN = 32;
function unpack_assets(input) {
    let numberOfAssets = input.length / PoolAsset.LEN;
    let output = [];
    let offset = 0;
    let zeroArray = new Int8Array(32);
    zeroArray.fill(0);
    for (let i = 0; i < numberOfAssets; i++) {
        let asset = PoolAsset.fromBuffer(input.slice(offset, offset + PoolAsset.LEN));
        if (asset.mintAddress.toString() !=
            new web3_js_1.PublicKey(Buffer.from(zeroArray)).toString()) {
            output.push(asset);
        }
        offset += PoolAsset.LEN;
    }
    return output;
}
exports.unpack_assets = unpack_assets;
function unpack_markets(input, numberOfMarkets) {
    let markets = new Array();
    let offset = 0;
    for (var i = 0; i < new Number(numberOfMarkets); i++) {
        markets.push(new web3_js_1.PublicKey(input.slice(offset, offset + 32)));
        offset += 32;
    }
    return markets;
}
exports.unpack_markets = unpack_markets;
//# sourceMappingURL=state.js.map